export function round(value: number, precision: number): number {
  return Math.round(value * 10 ** precision) / 10 ** precision;
}

export function calculatePercentageValue(value = 0, total = 0): number {
  if (!total || !value) {
    return 0;
  }
  return Number(((value / total) * 100).toFixed(0));
}

export function formatCounterValue(value: number): string {
  if (value >= 1_000_000_000_000) return "999B+";

  if (value < 1_000) {
    return `${Math.floor(value * 10) / 10}`;
  }

  if (value < 1_000_000) {
    // factor=10 keeps one decimal when the scaled result is < 100 (12.3k); factor=1 floors to an integer (123k).
    // Multiplying before dividing avoids float drift from `value / divisor` (e.g. 19.999… → 19.9, not 20).
    const factor = value < 100_000 ? 10 : 1;
    return `${Math.floor((value * factor) / 1_000) / factor}k`;
  }

  if (value < 1_000_000_000) {
    const factor = value < 100_000_000 ? 10 : 1;
    return `${Math.floor((value * factor) / 1_000_000) / factor}M`;
  }

  const factor = value < 100_000_000_000 ? 10 : 1;
  return `${Math.floor((value * factor) / 1_000_000_000) / factor}B`;
}

export function isCounterValueRounded(value: number): boolean {
  return value >= 1_000;
}
